import React from 'react';
import { useLocation } from 'react-router-dom';
import { loadQueryDevtools } from '@/config/env';
import { PATH } from '@/router/PATH';

const lazyDevtools = (load: NonNullable<typeof loadQueryDevtools>) =>
    React.lazy(() =>
        load().then((module) => ({ default: module.ReactQueryDevtools })),
    );

/**
 * A production bundle carries no devtools code: `loadQueryDevtools` is
 * `null` there, so the import is dropped at build time.
 */
const Devtools = loadQueryDevtools ? lazyDevtools(loadQueryDevtools) : null;

/**
 * React Query devtools, in development builds only (SEL-66). The floating
 * button picks a corner that covers nothing the screen needs: bottom-left on
 * the POS, which keeps its Pay button bottom-right, and bottom-right
 * elsewhere, where the admin sidebar footer (build commit, mode badge) sits
 * bottom-left. Must render inside the `QueryClientProvider` and the router.
 */
export const QueryDevtools: React.FC = () => {
    const { pathname } = useLocation();

    if (!Devtools) {
        return null;
    }

    const onTill = pathname.startsWith(PATH.SELLER);

    return (
        <React.Suspense fallback={null}>
            <Devtools
                buttonPosition={onTill ? 'bottom-left' : 'bottom-right'}
            />
        </React.Suspense>
    );
};
